/**
 * @file index.tsx
 *
 * @fileoverview Shows a placeholder for a organization profile.
 */

import Grid from "../../../../02-atoms/06-layout/04-grid";
import Cell from "../../../../02-atoms/06-layout/04-grid/01-cell";
import Spacing from "../../../../02-atoms/06-layout/07-spacing";
import Main from "../../../../02-atoms/06-layout/09-main";
import Box from "../../../../02-atoms/07-box";
import FormPlaceholder from "../../01-form";
import { ResumeTeaserPlaceholder } from "../../04-resume/02-teaser";
import OrganizationGalleryPlaceholder from "../02-gallery";
import styles from "./organizationDetailPlaceholder.module.scss";

/**
 * Placeholder skeleton for resume teaser for when page is loading.
 * Skeletons help provide some guidance to the user for
 * what the page will have while content is loading.
 */
export const OrganizationDetailPlaceholder = () => (
  <div>
    <div style={{ height: "200px", background: "#dedede" }}></div>
    <Main>
      <Box marginTop={["-20%", "-30px"]} className={styles.infoBox}>
        <div style={{ maxWidth: "800px" }}>
          <Spacing size="medium" />
          <ResumeTeaserPlaceholder />
        </div>
      </Box>
    </Main>
    <Spacing />
    <Main>
      <Grid gap={6} className={styles.grid}>
        <Cell display="grid">
          <Box>
            <div style={{ maxWidth: "800px" }}>
              <FormPlaceholder />
            </div>
          </Box>
        </Cell>
        <Cell display="grid">
          <Box>
            <div style={{ maxWidth: "800px" }}>
              <ResumeTeaserPlaceholder />
              <Spacing />
              <ResumeTeaserPlaceholder />
              <Spacing />
              <ResumeTeaserPlaceholder />
              <Spacing />
            </div>
          </Box>
        </Cell>
      </Grid>
    </Main>
    <Spacing />
    <Main>
      <Grid gap={6} className={styles.grid}>
        <Cell display="grid">
          <Box>
            <div style={{ maxWidth: "800px" }}>
              <FormPlaceholder />
            </div>
          </Box>
        </Cell>
        <Cell display="grid">
          <Box>
            <div style={{ maxWidth: "800px" }}>
              <FormPlaceholder />
              <Spacing />
            </div>
          </Box>
        </Cell>
      </Grid>
    </Main>
    <Spacing size="large" />
    <OrganizationGalleryPlaceholder />
    <Spacing size="large" />
    <Main>
      <div style={{ height: "400px", background: "#dedede" }}></div>
    </Main>
  </div>
);
